import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Place} from "../../model/place.model";
import {IonModal, IonSelect, NavController} from "@ionic/angular";
import {FirebaseService} from "../../service/firebase.service";
import {FirebaseEventEnum} from "../../enum/firebase-event.enum";
import {LocationService} from "../../service/location.service";
import {CommonService} from "../../service/common.service";
import {Category} from "../../model/category.model";

@Component({
  selector: 'app-place-item',
  templateUrl: './place-item.component.html',
  styleUrls: ['./place-item.component.scss'],
})
export class PlaceItemComponent implements OnInit {

  @ViewChild("actions", {static: true}) actions: IonSelect;

  @Input() place: Place<any>;
  @Input() showSkeleton: boolean;
  @Input() disableDetail: boolean;
  @Input() type: 'card' | 'chip' | 'horizontal' = 'card';

  categoryImage: string;
  modal: IonModal;
  showedCategory: Category;

  constructor(private navController: NavController,
              private commonService: CommonService,
              private firebaseService: FirebaseService) {
  }

  ngOnInit() {

    this.showedCategory = this.place?.categories?.find(item => item.parent || !item.parent);
    this.categoryImage = this.place?.categories.find(item => item.parent)?.iconUrl;
  }

  onOpenDetail() {

    if (this.disableDetail) {
      return;
    }

    if (this.place?.disablePlaceDetail) {

      this.firebaseService.logEvent(FirebaseEventEnum.CLICK_POI, {
        poi_name: this.place.name
      });

      this.actions.open();
    } else {
      this.navController.navigateForward(['/places', this.place.id]);
    }

  }

  onOpenMap() {
    this.commonService.openGoogleMapsByName(this.place?.name)
  }


  protected readonly parent = parent;
}
